/**
 * Cart Formatters - Consistent date/price/time formatting
 */

/**
 * Format price to USD currency
 * @param {number} amount - Price amount
 * @returns {string} Formatted price string
 */
export function formatCartPrice(amount) {
  if (typeof amount !== 'number') return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

/**
 * Format date to readable format
 * @param {string} dateStr - Date string (YYYY-MM-DD)
 * @returns {string} Formatted date (MMM DD)
 */
export function formatCartDate(dateStr) {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr + 'T00:00:00');
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(date);
  } catch (e) {
    return dateStr;
  }
}

/**
 * Format time to 12-hour format
 * @param {string} timeStr - Time string (HH:MM)
 * @returns {string} Formatted time (h:mm AM/PM)
 */
export function formatCartTime(timeStr) {
  if (!timeStr) return '';
  try {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  } catch (e) {
    return timeStr;
  }
}
